import React, { useEffect, useState } from 'react';
import './rainbow-divider.sass';
import { useMediaQueries } from '../../../../components/hooks/use-media-queries';

export const RainbowDividerTheme = {
  DARK: 'DARK',
  LIGHT: 'LIGHT'
};

export const RainbowDividerSideColors = {
  blue: '#5C57CB',
  lime: '#DFF9CE',
  black: '#000000',
  lightGray: '#EBEAF0'
};

const colorsDark = ['#EBEAF0', '#A09EAB', '#706E7E', '#4E4C5C', '#2B2A34', '#403D84', '#EBEAF0', '#A09EAB', '#706E7E', '#2B2A34'];
const colorsLight = ['#5C57CB', '#706E7E', '#8360CE', '#EA3FA9', '#BD7497', '#FF7C44', '#E6FF2E', '#3AC974', '#D9E58E', '#DFF9CE'];

const arrayStartEnd = {
  smm: {start: 2, end: 7},
  mdm: {start: 0, end: colorsDark.length},
  xl: {start: 0, end: colorsDark.length},
  xxl: {start: 0, end: colorsDark.length}
};

export const RainbowDivider = ({theme = RainbowDividerTheme.LIGHT, leftColor = RainbowDividerSideColors.blue, rightColor = RainbowDividerSideColors.lime}) => {

  const [rainbowRange, setRainbowRange] = useState({start: 0, end: colorsDark.length});
  const [colors, setColors] = useState([]);

  useEffect( () => {
    switch (theme) {
      case RainbowDividerTheme.DARK:
        setColors(colorsDark);
        break;

      case RainbowDividerTheme.LIGHT:
      default:
        setColors(colorsLight);
        break;
    }
  }, []);

  const onSmm = () => {
    setRainbowRange(arrayStartEnd.smm);
  };

  const onMdm = () => {
    setRainbowRange(arrayStartEnd.mdm);
  };

  const onXl = () => {
    setRainbowRange(arrayStartEnd.xl);
  };
  
  useMediaQueries({onSmm, onMdm, onXl});

  return (
    <div className='vv-rainbow-divider-container'>
      <div className='flex-item panel panel--left' style={{background: leftColor}}/>
        <div className='panel panel--middle'>
          {
            colors.slice(rainbowRange.start, rainbowRange.end).map((color, i) => <div key={i} className='flex-item' style={{background: color}}/>)
          }
        </div>
      <div className='flex-item panel panel--right' style={{background: rightColor}}/>
    </div>
  );
};
